import SignUp from 'components/pages/SignUp/SignUp';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('registration-login', {
  withoutSubNav: true,
});

export default buildPage(SignUp, {
  skipSSR: true,
  metaData: {
    title: 'Sign Up',
    description: 'Please log in or sign up',
  },
  loggedInRedirect: '/register-success',
});
